var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/**
 * A parser that given an SDMX Artefacts List Response and parsing options (properties from the request),
 * will parse the overall artefacts (without sub values details, no codes for codelists for instance),
 * and return them in the form of an object.
 *
 * @memberOf SDMXJS
 * @api public
 * @tag function
 * @param {Object}
 * @return {Object}
 *
 * @example
 * const sdmxJson = {
 *   data: {
 *     dataflows: [
 *       { id: 'DF1', version: 'V1', agencyID: 'A1', name: 'dataflow1', isFinal: false },
 *       { id: 'DF2', version: 'V2', agencyID: 'A2', isFinal: true },
 *     ],
 *   },
 * };
 *
 * const parseOptions = { space: { id: 'sp' }, type: 'dataflow' };
 *
 * const parsedDataflows = SDMXJS.parseOverviewStructureList(parseOptions)(sdmxJson);
 * //=>{
 * //   'sp:dataflow:A1:DF1(V1)': {
 * //      code: 'DF1', label: 'dataflow1', isFinal: false, agencyId: 'A1', sdmxId: 'A1:DF1(V1)',
 * //      space: { id: 'sp' }, id: 'sp:dataflow:A1:DF1(V1)', type: 'dataflow', version: 'V1'
 * //    },
 * //    'sp:dataflow:A2:DF2(V2)': {
 * //      code: 'DF2', label: '[DF2]', isFinal: true, agencyId: 'A2', sdmxId: 'A2:DF2(V2)',
 * //      space: { id: 'sp' }, id: 'sp:dataflow:A2:DF2(V2)', type: 'dataflow', version: 'V2'
 * //    },
 * //  };
 */
import * as R from 'ramda';
import { LISTS } from './constants/types';
export var parseOverviewStructureList = function parseOverviewStructureList(_ref) {
  var agencyIds = _ref.agencyIds,
    fromCategory = _ref.fromCategory,
    space = _ref.space,
    type = _ref.type;
  return function (sdmxJson) {
    return R.pipe(R.prop('data'), R.ifElse(R.always(type === 'all'), R.values, R.pipe(R.prop(LISTS[type]), function (list) {
      return [list];
    })), R.reduce(function (acc, list) {
      var parsedList = R.reduce(function (acc, artefact) {
        var _extends2;
        var agencyId = artefact.agencyID;
        var code = artefact.id;
        var version = artefact.version;
        var isFinal = artefact.isFinal;
        var label = R.prop('name')(artefact);
        var sdmxId = agencyId + ':' + code + '(' + version + ')';
        var id = space.id + ':' + type + ':' + sdmxId;
        return _extends({}, acc, (_extends2 = {}, _extends2[id] = {
          agencyId: agencyId,
          code: code,
          version: version,
          type: type,
          isFinal: isFinal,
          label: label,
          sdmxId: sdmxId,
          id: id,
          space: space
        }, _extends2));
      }, {}, list);
      return R.merge(acc, parsedList);
    }, {}), R.when(R.always(fromCategory && !R.isEmpty(agencyIds)), R.filter(R.pipe(R.prop('agencyId'), R.flip(R.includes)(agencyIds)))))(sdmxJson);
  };
};